"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function FieldErrorIcon() {
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "payment-checkout-input__inline-validation payment-checkout-input__inline-validation--invalid"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 9.44086 15.6398 10.7742 14.9194 12C14.1989 13.2258 13.2258 14.1989 12 14.9194C10.7742 15.6398 9.44086 16 8 16C6.55914 16 5.22581 15.6398 4 14.9194C2.77419 14.1989 1.80108 13.2258 1.08065 12C0.360215 10.7742 0 9.44086 0 8C0 6.55914 0.360215 5.22581 1.08065 4C1.80108 2.77419 2.77419 1.80108 4 1.08065C5.22581 0.360215 6.55914 0 8 0C9.44086 0 10.7742 0.360215 12 1.08065C13.2258 1.80108 14.1989 2.77419 14.9194 4C15.6398 5.22581 16 6.55914 16 8ZM8.01613 10C7.60308 10 7.24982 10.1467 6.95635 10.4402C6.66287 10.7337 6.51613 11.087 6.51613 11.5C6.51613 11.913 6.66287 12.2663 6.95635 12.5598C7.24982 12.8533 7.60308 13 8.01613 13C8.42917 13 8.78243 12.8533 9.07591 12.5598C9.36939 12.2663 9.51613 11.913 9.51613 11.5C9.51613 11.087 9.36939 10.7337 9.07591 10.4402C8.78243 10.1467 8.42917 10 8.01613 10ZM6.58064 3.41935L6.83871 7.80645C6.83871 7.89247 6.87634 7.97312 6.95161 8.04839C7.02688 8.12366 7.11828 8.16129 7.2258 8.16129H8.77419C8.88172 8.16129 8.97312 8.12366 9.04838 8.04839C9.12365 7.97312 9.16129 7.89247 9.16129 7.80645L9.41935 3.41935C9.41935 3.29032 9.38172 3.18817 9.30645 3.1129C9.23118 3.03763 9.13978 3 9.03226 3H6.96774C6.86021 3 6.76881 3.03763 6.69355 3.1129C6.61828 3.18817 6.58064 3.29032 6.58064 3.41935Z",
    fill: "#D10244"
  })));
}
var _default = FieldErrorIcon;
exports.default = _default;